module.exports = "/images/vn.svg?894ca8effd1ff75b5a21351e9e4de9ce";